import {
	AvailabilityFetchProps,
	ProductTotalAvailability,
} from 'common/api/frontend/inventory_new/types';
import { CallableCreator } from '..';

export const availability = (createCallable: CallableCreator) => ({
	getQuantitiesAndAvailabilities: createCallable<AvailabilityFetchProps, ProductTotalAvailability>(
		'availability-getQuantitiesAndAvailabilities',
	),
});
